<div class="flex flex-row items-center justify-between p-3 rounded-lg cursor-pointer transition-colors"
     [ngClass]="{'bg-zaeper-primary-50': isActive, 'hover:bg-surface-100 dark:hover:bg-surface-800': !isActive}"
     (click)="selectReceiver()">
  <div class="flex flex-row items-center gap-3">
    <i class="pi pi-desktop text-xl text-surface-600 dark:text-surface-300"></i>
    <div class="flex flex-col">
      <span class="font-medium">{{ receiver.name }}</span>
      <span class="text-xs text-surface-500 dark:text-surface-400">{{ receiver.osType }} {{ receiver.osVersion }}</span>
    </div>
  </div>
  <app-online-status-indicator [isOnline]="receiver.isOnline" [showLabel]="false" size="small"/>
</div>
